import { urls } from '@/config/urls';
import { instance } from '@/config/axios';

const { server } = urls;

export default {

  abortFetch () {

  },

  getSettingsAsync () {
    return instance.get(`${server.settings.settingsData}?q={"filters":[{"name":"key","op":"in","val":["SYSTEM_LANGUAGE",
    "LOAD_DIMENSIONS", "DEFAULT_DAY_START", "DEFAULT_DAY_END"]}]}`);
  },

  getMetabaseDashboard (payload) {
    return instance.post(server.dashboard, {
      dashboard_id: payload.dashboard ?? null,
      filters: {
        optimization_id: payload.optimization_id || '',
        date: payload.date || '',
        site_name:payload.site_name || ''
      }
    }).then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

};
